<template>
  <svg class="w-3 h-3 shrink-0" viewBox="0 0 12 12" fill="currentColor">
    <!-- Up arrow -->
    <path :opacity="active && asc ? 1 : 0.3"
      d="M6 1L10 5H2L6 1Z"/>
    <!-- Down arrow -->
    <path :opacity="active && !asc ? 1 : 0.3"
      d="M6 11L2 7H10L6 11Z"/>
  </svg>
</template>

<script setup>
defineProps({
  active: Boolean,
  asc:    Boolean,
})
</script>
